import { DC } from "../../constants";

// I tried to make it relatively simple to add more locks; the idea is that you give it a value here
// and then it's all handled in the backend
// If you need to lock a challenge, set lockedAt to a new Decimal variable reflective of a desired number of Infinities
// They will always be unlocked post-eternity

export const normalChallenges = [
  {
    id: 1,
    legacyId: 1,
    isQuickResettable: false,
    description() {
      return PlayerProgress.eternityUnlocked()
        ? "достигните Бесконечности впервые за пределами челленджа."
        : "достигните Бесконечность в первый раз.";
    },
    name: "АвтоПокупщик 1ого Измерения Антиматерии",
    reward: "Улучшаемый АвтоПокупщик 1ого Измерения Антиматерии",
    lockedAt: DC.D0,
  },
  {
    id: 2,
    legacyId: 2,
    isQuickResettable: false,
    description:
      () => "покупка Измерений Антиматерии или улучшения Скорость Тика задерживает проиводитство всех Измерений " +
      `Антиматерии. Производство постепенно возвращается в норму на протяжении ${formatInt(3)} минут.`,
    name: "АвтоПокупщик 2ого Измерения Антиматерии",
    reward: "Улучшаемый АвтоПокупщик 2ого Измерения Антиматерии",
    lockedAt: DC.D0,
  },
  {
    id: 3,
    legacyId: 3,
    isQuickResettable: false,
    description:
      `1ое Измерение Антиматерии значительно ослаблено, но получает неограниченный экспоненциально нарастающий
      множитель. Этот множитель перезапускается после покупки Буста Измерений или Галактики Антиматерии.`,
    name: "3ье Измерение Антиматерии",
    reward: "Улучшаемый АвтоПокупщик 3его Измерения Антиматерии",
    lockedAt: DC.D0,
  },
  {
    id: 4,
    legacyId: 8,
    isQuickResettable: false,
    description: "покупка Измерения Антиматерии автоматически стирает все нижние Измерения Антиматерии, " +
      "как жертвование но без бонуса.",
    name: "АвтоПокупщик 4ого Измерения Антиматерии",
    reward: "Улучшаемый АвтоПокупщик 4ого Измерения Антиматерии",
    lockedAt: DC.D0,
  },
  {
    id: 5,
    legacyId: 6,
    isQuickResettable: false,
    description:
      () => `множитель покупки Скорости Тика начанается с ${formatX(1.080, 0, 3)} вместо ${formatX(1.1245, 0, 3)}.`,
    name: "АвтоПокупщик 5ого Измерения Антиматерии",
    reward: "Улучшаемый АвтоПокупщик 5ого Измерения Антиматерии",
    lockedAt: DC.D0,
  },
  {
    id: 6,
    legacyId: 10,
    isQuickResettable: false,
    description: () => `улучшение каждого Измерения Антиматерии стоит цену Измерений Антиматерии ${
      formatInt(2)} уровней ниже него вместо антиматерии. Цены Измерений Антиматерии не изменены.`,
    name: "АвтоПокупщик 6ого Измерения Антиматерии",
    reward: "Улучшаемый АвтоПокупщик 6ого Измерения Антиматерии",
    lockedAt: DC.D0,
  },
  {
    id: 7,
    legacyId: 9,
    isQuickResettable: false,
    description: () =>
      `множитель от покупки ${formatInt(10)} Измерений Антиматерии уменьшен до ${formatX(1)}. Он увеличивается на
        ${formatX(0.2, 1, 1)} за Буст Измерений, до максимума в ${formatX(2)}, и не зависит ни от каких улучшений.`,
    name: "АвтоПокупщик 7ого Измерения Антиматерии",
    reward: "Улучшаемый АвтоПокупщик 7ого Измерения Антиматерии",
    lockedAt: DC.D0,
  },
  {
    id: 8,
    legacyId: 11,
    isQuickResettable: false,
    description: `Бусты Измерений не дают никакого множителя, а Галактики Антиматерии не могут быть куплены. Жертвование
      Измерений сбрасывает антиматерию и все Измерения Антиматерии, но также даёт гораздо болеё мощный множитель.`,
    name: "АвтоПокупщик 8ого Измерения Антиматерии",
    reward: "Улучшаемый АвтоПокупщик 8ого Измерения Антиматерии",
    lockedAt: DC.D0,
  },
  {
    id: 9,
    legacyId: 5,
    isQuickResettable: true,
    description: () => `каждый раз, когда вы покупаете улучшение Скорости Тика или ${formatInt(10)} Измерений, ` +
      "Антиматерии, всё, что имеет такую же цену, будет повышено до следующей ступени цены.",
    name: "АвтоПокупщик Скорости Тика",
    reward: "Улучшаемый АвтоПокупщик Скорости Тика",
    lockedAt: DC.D0,
  },
  {
    id: 10,
    legacyId: 4,
    isQuickResettable: false,
    description: () => `существует всего ${formatInt(6)} Измерений Антиматерии. Цены Бустов Измерений ` +
      "и Галактик Антиматерии изменены.",
    name: "Автоматизированные Бусты Измерений",
    reward: "АвтоПокупщик Бустов Измерений",
    lockedAt: DC.D16,
  },
  {
    id: 11,
    legacyId: 12,
    isQuickResettable: true,
    description: () => `существует обычная материя, которая начинает увеличиваться как только вы имеете хотя бы
    ${formatInt(1)} Измерение Антиматерии. ` +
      "Если она превышает количество вашей антиматерии, она сделает Буст Измерения без бонуса.",
    name: "Автоматизированные Галактики Антиматерии",
    reward: "АвтоПокупщик Галактик Антиматерии",
    lockedAt: DC.D16,
  },
  {
    id: 12,
    legacyId: 7,
    isQuickResettable: false,
    description: () => `каждое Измерение Антиматерии производит Измерение ${formatInt(2)} уровнями ниже него
      вместо ${formatInt(1)}. И 1ое и 2ое Измерения производят антиматерию.
      2ое, 4ое и 6ое Измерения усилены.`,
    name: "Автоматизированные Большие Хрусты",
    reward: "АвтоПокупщик Большого Хруста",
    lockedAt: DC.D16,
  }
];
